import type {FixButtonVariant} from '@Components/social-media/components/fix-this-button';

export const BADGE_ICON = 'icon-exclamation-triangle';

export interface SocialErrorCardSecondaryAction {
  label: string;
  onClick: () => void;
}

export interface SocialErrorCardProps {
  message: string;
  onFixThis: () => void;
  isFixing?: boolean;
  disabled?: boolean;
  fixButtonType?: FixButtonVariant;
  secondaryAction?: SocialErrorCardSecondaryAction;
}
